'use strict';

require('../modules/collections/boarding_options/boarding_options.collection').getInstance({load: true});
const baggagesCollectionBuilder = require('../modules/builders/baggages').getInstance();
const ancillariesStep = require('../modules/handlers/ancillaries_step');
const priceManagerCollection = require('../modules/collections/pricemanager.collection').getInstance();
const handlerUtils = require('../modules/handlers/ancillaries').default;
const stickySeatsLeftUtils = require('../modules/sticky_seats_left/utils');

Odigeo.Router.handlers.metaancillaries = function() {
    const $page = $('#metaancillaries');
    const widgets = handlerUtils.widgets;
    const isSidebarSummary = $('.side_summary_payment').data('type') === 'sidebarsummary';

    const asyncWidgets = Odigeo.autoloadWidgetsAsync({
        getPriceManagerEnhanced: ['price-breakdown-payments', 'pricemanager_enhanced'],
        getSidebar: isSidebarSummary ? ['sidebar-summary-payment', 'sidebar_summary'] : ['trip-summary-price-payment', 'trip_summary_price'],
        getSpecialrequestManager: ['specialrequest', 'special_request_manager'],
        getAncillariesModule: ['ancillaries-module', 'ancillaries_module'],
        getAncillariesDebugInfo: ['ancillaries-debuginfo', 'ancillaries_debuginfo'],
        getFlightSummary: ['collapsible-flight-summary', 'collapsible_flight_summary'],
    });

    baggagesCollectionBuilder.buildCollection();

    const ancillariesContinueButtonAction = function() {
        asyncWidgets.getSpecialrequestManager().execute('setBookingUserComments').then(() => {
            Odigeo.Router.navigate('payment');
        });
    };

    priceManagerCollection.fetchData();

    Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController,
        Odigeo.Router.handlers.globalEventController,
        Odigeo.Router.handlers.errorManagerEventController,
        {
            globalEvents: {},
            viewEvents: Odigeo._.extend(handlerUtils.viewEvents(), {
                'sidebar-summary-payment:openFlightDetails': 'onOpenFlightDetailsAncillaries',
                'sidebar-summary-payment:launchPopupSidebar': 'onLaunchPopupFlightDetailSummary',
            }),
            eventHandlers: Odigeo._.extend(handlerUtils.eventHandlers(), {
                onOpenFlightDetailsAncillaries: function(event, hasToTrack) {
                    Odigeo.requireWidget('flight-details-ancillaries', 'flight_details', function(flightDetails) {
                        flightDetails.execute('toggleViewPanel', event, hasToTrack);
                    });
                },
                onLaunchPopupFlightDetailSummary: function() {
                    asyncWidgets.getFlightSummary().execute('launchPopupMetaanc');
                },
            }),
        }
    );

    Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
    $page.find('.seats_left_top_metaancillaries').removeClass('od-sticky-seats-left');
    $page.find('.ancillaries_page_step_button').on(Odigeo.Events.tap, Odigeo._.bind(Odigeo._.debounce(ancillariesContinueButtonAction, 1000), this));

    widgets.nagManager().execute('updateState');
    asyncWidgets.getAncillariesModule().execute('fetchData');
    asyncWidgets.getAncillariesDebugInfo().execute('load');
    widgets.getServiceoptionsTableManager().execute('load');
    asyncWidgets.getFlightSummary().execute('load');

    ancillariesStep.init();

    if (isSidebarSummary) {
        asyncWidgets.getSidebar().execute('updatePage', 'payment');
    }

    Odigeo.Router.eventController.execute();

    handlerUtils.windowScroll();

    handlerUtils.tablePaxDetails('flight-details-ancillaries');

    Odigeo.requireWidget('flight-details-ancillaries', 'flight_details', function(widget) {
        widget.execute('refreshPaxData');
    });

    if (!Odigeo.AB.isTicketsLeftNextToContinueDetails) {
        stickySeatsLeftUtils.stickyTopSeats($page.find('.seats_left_top_metaancillaries'), 'seatsLeftTopStickyMetaancillaries');
    }
};
